import React from 'react';
import { Col, Container } from 'react-bootstrap';
import Message from './message_summarizey.jsx'

function SummarizeWithCol({ height, message, saveRequested, onSaved }) {
  return (
    // <Col style={{ height: height }}>
    <Col>
      <main className="main is-visible" data-dropzone-area="">
        <Container className='h-100'>
          <div className='d-flex flex-column h-100 position-relative'>
            <div className="chat-body flex-1 h-100">
              <div className="chat-body-inner" style={{ paddingBottom: "71px" }}>
                <div className="py-6 py-lg-12">
                  <Message
                    message={message}                    
                    saveRequested={saveRequested}
                    onSaved={onSaved}
                  />
                </div>
              </div>
            </div>
          </div>
        </Container>
      </main>
    </Col>
  );
}

export default SummarizeWithCol;